// Mega menu product swap: hovering or focusing a sub-collection link ([data-feat]) shows that collection's
// product panel ([data-feat-panel]); leaving the dropdown resets to the parent's panel (key ending "-0").
for (const root of document.querySelectorAll('[data-nav-feature]')) {
  const panels = [...root.querySelectorAll('[data-feat-panel]')];
  if (panels.length < 2) continue;
  const links = [...root.querySelectorAll('[data-feat]')];
  const defaultKey = panels[0].dataset.featPanel;

  const show = (key) => {
    const target = panels.find((p) => p.dataset.featPanel === key) ? key : defaultKey;
    for (const panel of panels) {
      const on = panel.dataset.featPanel === target;
      panel.classList.toggle('invisible', !on);
      panel.classList.toggle('opacity-0', !on);
      for (const a of panel.querySelectorAll('a')) on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1');
    }
    for (const link of links) link.toggleAttribute('data-active', link.dataset.feat === key && target === key);
  };

  for (const link of links) {
    link.addEventListener('pointerenter', () => show(link.dataset.feat));
    link.addEventListener('focus', () => show(link.dataset.feat));
  }
  root.addEventListener('pointerleave', () => show(defaultKey));
}
